const config = {
    build_number: '616541',
    build_timestamp: '2026-10-02T16:50:45.792Z',
    build_commit: '269ff92d6cfbb7cfbba2523bb8f140faf726fbc6',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
